/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { AccessDeniedComponent } from './auth/pages/access-denied/access-denied.component';
import { AdministrationComponent } from './pages/administration/administration.component';
import { canActivateAuthFeedback, canActivateAuthRole } from './auth/guards/auth.guard';
import { LoginErrorComponent } from './auth/pages/login-error/login-error.component';
import { LoggedInComponent } from './auth/pages/logged-in/logged-in.component';
import { CatalogComponent } from './pages/catalog/catalog.component';
import { RoleComponent } from './shared/role/role.component';
import { HomeComponent } from './pages/home/home.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'login-error',
        component: LoginErrorComponent,
        canActivate: [canActivateAuthFeedback]
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent,
        canActivate: [canActivateAuthFeedback]
    },
    {
        path: 'logged-in',
        component: LoggedInComponent
    },
    { 
        path: '', 
        redirectTo: 'home', 
        pathMatch: 'full' 
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [canActivateAuthRole],
        data: { roles: ["ds-catalog-user", "ds-catalog-administrator"] },
        children: [
            { 
                path: '',
                redirectTo: '',
                pathMatch: 'full'
            },
            {
                path: 'role',
                component: RoleComponent,
                canActivate: [canActivateAuthRole],
                data: { roles: ["ds-catalog-user", "ds-catalog-administrator"] }
            },
            { 
                path: 'administration', 
                component: AdministrationComponent,
                canActivate: [canActivateAuthRole],
                data: { roles: ["ds-catalog-administrator"] }
            },
            { 
                path: 'catalog', 
                component: CatalogComponent,
                canActivate: [canActivateAuthRole],
                data: { roles: ["ds-catalog-user", "ds-catalog-administrator"] }
            },
        ]
    }
];